// Editorial women-of-color imagery for course tiles + collection banners.
// Ethnicity-specific collections draw ONLY from a photo pool that matches that
// community, and each pool holds enough distinct photos (15 where the stock
// libraries allow) so tiles within a collection don't repeat.
const P = "?crop=entropy&cs=srgb&fm=jpg&q=80&w=800";
const u = (id) => `https://images.unsplash.com/${id}${P}`;
const uWide = (id) => `https://images.unsplash.com/${id}?crop=entropy&cs=srgb&fm=jpg&q=80&w=1400`;
const PX = (id) =>
  `https://images.pexels.com/photos/${id}/pexels-photo-${id}.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940`;

// Pan-ethnic "learning area" tiles — not tied to a specific community.
const GENERIC = {
  "confidence-identity": u("photo-1619694770795-e21c58464159"),
  mindset: u("photo-1619799087179-061f19622476"),
  "emotional-wellness": u("photo-1593351799227-75df2026356b"),
  "boundaries-communication": u("photo-1604364721460-0cbc5866219d"),
  relationships: u("photo-1684361436003-aa575b96bc2d"),
  "motherhood-family": u("photo-1536013009411-25930e88d3c7"),
  "career-leadership": u("photo-1632765866070-3fadf25d3d5b"),
  money: u("photo-1579017308347-e53e0d2fc5e9"),
  "habits-routines": u("photo-1594089425711-2381a2fbca6b"),
  "stress-rest": u("photo-1639325723366-1759d5d74959"),
  purpose: u("photo-1741253323551-8d774db9d956"),
  "faith-spirituality": u("photo-1600144559281-53d1dee79a99"),
  "hair-beauty": u("photo-1632765854612-9b02b6ec2b15"),
  "race-identity": u("photo-1611432579402-7037e3e2c1e4"),
  "singleness-dating": u("photo-1767396857204-3b077ff8db1f"),
  codependency: u("photo-1527203561188-dae1bc1a417f"),
  "grief-loss": u("photo-1534806596185-c4a911703708"),
  "body-image": u("photo-1617551307538-c9cdb9d71289"),
  intimacy: u("photo-1765292783761-cd5689dbdc91"),
  "divorce-rebuilding": u("photo-1585059896947-f99dd6c80101"),
  menopause: u("photo-1511945863317-d60e146e9016"),
  friendship: u("photo-1517840933437-c41356892b35"),
  "self-compassion": u("photo-1593351799227-75df2026356b"),
  "forgiveness-letting-go": u("photo-1534806596185-c4a911703708"),
  "courage-risk": u("photo-1741253323551-8d774db9d956"),
  "gratitude-joy": u("photo-1517840933437-c41356892b35"),
  "life-hacks": u("photo-1558478551-aca3709bb312"),
  "living-between-cultures": u("photo-1607749111659-e1c8e05f5f24"),
  "lbc-latina": u("photo-1601831155536-39cc6afbd284"),
  "lbc-south-asian": u("photo-1758600587815-b654d1405e83"),
  "lbc-african": u("photo-1613876215075-276fd62c89a4"),
};

// Ethnicity-matched photo pools (women of each community only).
const POOLS = {
  aa: [
    u("photo-1656473031961-9d5d9ee19f40"), u("photo-1632765866070-3fadf25d3d5b"),
    u("photo-1563132337-f159f484226c"), u("photo-1592520113018-180c8bc831c9"),
    PX(20082055), PX(33141463), u("photo-1686318779895-760218cb319e"),
    u("photo-1763750582862-89e35f55378e"), PX(36720012), PX(31987393),
    u("photo-1656473040206-53753fbbc767"), u("photo-1662850886700-4ec19bd30d11"),
    u("photo-1758600434261-91651d3cdbc4"), u("photo-1645841307001-d48e76d0fa15"),
    u("photo-1613876215075-276fd62c89a4"),
  ],
  lat: [
    u("photo-1523761415282-2106778cfb5a"), u("photo-1506863530036-1efeddceb993"),
    u("photo-1644718847151-fff2271484a1"), PX(38468701), PX(28224108),
    u("photo-1778774538481-cb567d622de0"), u("photo-1739785249445-ad56ee661fcc"),
    u("photo-1783690898259-87b7d60eb6f4"), u("photo-1780396700817-2ec700591808"),
    PX(15136211), PX(13305461), u("photo-1560812241-84976e344e2a"),
    u("photo-1762827646148-4f2229937ded"), u("photo-1617296538902-887900d9b592"),
    PX(21926522),
  ],
  sa: [
    u("photo-1756355201306-b224f64c379b"), u("photo-1756355201570-4437a6e34717"),
    u("photo-1771507057209-08252afbe9ef"), u("photo-1772269768593-3a9814a67323"),
    u("photo-1710972197951-3aade7376076"), u("photo-1463335361701-e90f4c5045d0"),
    PX(29601839), PX(38451328), u("photo-1759840278361-f1adc75529a1"),
    u("photo-1770838447126-2e5f9207a6ab"), u("photo-1771507056806-10cb8c81464c"),
    PX(30364581), u("photo-1516239482977-b550ba7253f2"),
    u("photo-1680506742421-7420d343bf68"), u("photo-1731138077443-37ad0b68ca79"),
  ],
  mena: [
    u("photo-1675509682819-d751ae7566c4"), u("photo-1653641621097-d25366c2c6a4"),
    u("photo-1601117830731-1a36c879f666"), u("photo-1617077644557-64be144aa306"),
    u("photo-1634595477722-7bc68dd410fd"), PX(31976946),
    u("photo-1652784549134-bae822a7c4a3"), PX(23092165),
    PX(6036648), u("photo-1762344346976-f9721b56cf55"),
    u("photo-1682616443645-a7526f633c83"), u("photo-1762605135326-5c4bcc5ef006"),
    PX(14724551), u("photo-1692210240763-5b381163dbfc"), PX(4496339),
  ],
  carib: [
    u("photo-1642912274012-d410fc2bc18e"), u("photo-1759807966328-7379fadd1fd6"),
    u("photo-1771860108097-9e4214acfd37"), u("photo-1642912274838-106681ffab86"),
    PX(28168488), PX(18296716), u("photo-1505421031134-e57263cae630"),
    u("photo-1532076904124-d4e8fe7fbbec"), u("photo-1534470717-233b39a41c54"),
    PX(34324837), PX(34324833), u("photo-1523297736436-356615162cc8"),
    PX(32463151), PX(31514197), u("photo-1592520113018-180c8bc831c9"),
  ],
  ea: [
    u("photo-1589525231707-f2de2428f59c"), u("photo-1624091844772-554661d10173"),
    u("photo-1600481176431-47ad2ab2745d"), u("photo-1521227889351-bf6f5b2e4e37"),
    PX(801618), PX(1124833), u("photo-1498090890888-3df9298e7b84"),
    u("photo-1706153068774-5271417921a4"), PX(27593344), PX(25473738),
    u("photo-1695757002354-8bca71d087c7"), u("photo-1641351841616-faa0d3760980"),
    u("photo-1687298703924-0d11be697d8b"), u("photo-1516007223491-7753f0689511"),
  ],
  af: [
    u("photo-1505421031134-e57263cae630"), u("photo-1532076904124-d4e8fe7fbbec"),
    u("photo-1613876215075-276fd62c89a4"), u("photo-1534470717-233b39a41c54"),
    PX(34324837), PX(34324833), u("photo-1709809081557-78f803ce93a0"),
    PX(34752891), PX(33536933), u("photo-1523297736436-356615162cc8"),
    PX(32463151), PX(31514197), u("photo-1686318779895-760218cb319e"),
    u("photo-1763750582862-89e35f55378e"), PX(36720012),
  ],
  in: [
    u("photo-1584348050233-e5f67d0b13e1"), u("photo-1582140161498-41c99a3721e5"),
    u("photo-1584348075578-a32526a25f70"), PX(36361460), PX(36361491),
    u("photo-1720239363562-260894edb985"), u("photo-1724521260101-c13e61992638"),
    PX(12620914), u("photo-1722278972871-637fca3751c4"),
    u("photo-1752446816516-740a0211a0c6"), PX(33760929), PX(1432238),
  ],
  pi: [
    u("photo-1548966067-aaa21b5f8112"), u("photo-1690997711864-e780f92396ed"),
    PX(20736371), PX(32141147), PX(32014985), u("photo-1610413322878-ee8c50e10a82"),
    u("photo-1711060266386-ad15553add61"), u("photo-1619188995819-51b9bfb07ccb"),
    u("photo-1733714090803-28af18de0512"), u("photo-1547941269-2582b3914420"),
    u("photo-1741805190372-26d5e8130aae"),
  ],
  mx: [
    u("photo-1619799087179-061f19622476"), u("photo-1644718847160-52a922094f69"),
    PX(16176593), PX(5935268), u("photo-1645841307001-d48e76d0fa15"),
    u("photo-1662850886700-4ec19bd30d11"), u("photo-1758600434261-91651d3cdbc4"),
    u("photo-1656473040206-53753fbbc767"), PX(9166822), PX(7048345),
    u("photo-1763750582862-89e35f55378e"), u("photo-1686318779895-760218cb319e"),
    u("photo-1523761415282-2106778cfb5a"), u("photo-1506863530036-1efeddceb993"),
    u("photo-1656473031961-9d5d9ee19f40"),
  ],
  jw: [
    u("photo-1670840239184-2790ed2f7404"), u("photo-1710452772856-57452a2a60a5"),
    u("photo-1577584402387-943276baf178"), PX(4040830), PX(4040840),
    u("photo-1607746882042-944635dfe10e"), u("photo-1646293890121-b16539364dcc"),
    u("photo-1564564295391-7f24f26f568b"), u("photo-1477118476589-bff2c5c4cfbb"),
    PX(4038110), PX(6116042), u("photo-1777594423247-34c664dcaa09"),
    u("photo-1695272279949-a909eff8352a"), u("photo-1733264608983-6f60186e1fc5"),
    u("photo-1589114473009-c86eec4e5630"),
  ],
  // Immigrant & first-gen is intentionally pan-ethnic (a diverse blend).
  im: [
    u("photo-1516007223491-7753f0689511"), u("photo-1523761415282-2106778cfb5a"),
    u("photo-1589525231707-f2de2428f59c"), u("photo-1710972197951-3aade7376076"),
    u("photo-1656473031961-9d5d9ee19f40"), u("photo-1545266241-3516e2a6e016"),
    u("photo-1642912274012-d410fc2bc18e"), u("photo-1584348050233-e5f67d0b13e1"),
    u("photo-1548966067-aaa21b5f8112"), u("photo-1670840239184-2790ed2f7404"),
    u("photo-1778774538481-cb567d622de0"), u("photo-1498090890888-3df9298e7b84"),
    u("photo-1505421031134-e57263cae630"), u("photo-1619799087179-061f19622476"),
    u("photo-1756355201306-b224f64c379b"),
  ],
};

// Course tile keys per collection, in display order.
const KEYS = {
  mena: ["mena-making-it", "mena-between-worlds", "mena-good-daughter", "mena-ambition", "mena-beauty", "mena-love-marriage", "mena-eldest-daughter", "mena-parents-sacrifice", "mena-money-class", "mena-anger", "mena-motherhood-gen", "mena-friendship", "mena-body-culture", "mena-divorce", "mena-faith-voice"],
  aa: ["aa-strong-woman", "aa-softness", "aa-crown-hair", "aa-colorism", "aa-anger-myth", "aa-code-switching", "aa-love-dating", "aa-money-legacy", "aa-motherhood", "aa-faith-church", "aa-body-health", "aa-sisterhood", "aa-at-work", "aa-generational-healing", "aa-joy-rest"],
  lat: ["lat-marianismo", "lat-familia-boundaries", "lat-two-worlds", "lat-colorism", "lat-machismo-love", "lat-first", "lat-ambition", "lat-money", "lat-motherhood", "lat-mental-health", "lat-body", "lat-sisterhood", "lat-anger", "lat-faith", "lat-joy"],
  sa: ["sa-good-daughter", "sa-family-duty", "sa-two-worlds", "sa-colorism", "sa-marriage", "sa-expectation", "sa-ambition", "sa-money", "sa-motherhood", "sa-mental-health", "sa-body", "sa-sisterhood", "sa-anger", "sa-faith", "sa-joy"],
  carib: ["carib-strong-woman", "carib-family-boundaries", "carib-two-worlds", "carib-colorism", "carib-respectability", "carib-love-relationships", "carib-ambition", "carib-money", "carib-motherhood", "carib-mental-health", "carib-body", "carib-sisterhood", "carib-anger-voice", "carib-faith-roots", "carib-joy"],
  ea: ["ea-model-minority", "ea-filial", "ea-face", "ea-beauty", "ea-voice", "ea-becoming", "ea-love", "ea-parents", "ea-money", "ea-mental-health", "ea-body-food", "ea-work", "ea-motherhood", "ea-sisterhood", "ea-joy"],
  af: ["af-strong", "af-family", "af-marriage", "af-beauty", "af-voice", "af-roots", "af-love", "af-motherhood", "af-money", "af-work", "af-mental-health", "af-body", "af-sisterhood", "af-diaspora", "af-joy"],
  in: ["in-identity", "in-historical", "in-land", "in-voice", "in-becoming", "in-family", "in-love", "in-motherhood", "in-body", "in-mental-health", "in-money", "in-work", "in-sisterhood", "in-food", "in-joy"],
  pi: ["pi-identity", "pi-family", "pi-body", "pi-roots", "pi-love", "pi-motherhood", "pi-mental-health", "pi-money", "pi-work", "pi-sisterhood", "pi-food", "pi-voice", "pi-faith", "pi-joy", "pi-becoming"],
  mx: ["mx-belonging", "mx-identity", "mx-family", "mx-becoming", "mx-love", "mx-motherhood", "mx-body", "mx-mental-health", "mx-money", "mx-work", "mx-sisterhood", "mx-voice", "mx-faith", "mx-food", "mx-joy"],
  im: ["im-two-worlds", "im-family", "im-belonging", "im-becoming", "im-love", "im-motherhood", "im-work", "im-money", "im-mental-health", "im-body", "im-voice", "im-sisterhood", "im-language", "im-faith", "im-joy"],
  jw: ["jw-identity", "jw-inherited", "jw-expectation", "jw-becoming", "jw-love", "jw-motherhood", "jw-body", "jw-voice", "jw-money", "jw-mental-health", "jw-sisterhood", "jw-faith-ritual", "jw-food", "jw-safety", "jw-joy"],
};

const buildTiles = () => {
  const out = {};
  for (const group of Object.keys(KEYS)) {
    const pool = POOLS[group];
    KEYS[group].forEach((key, i) => {
      out[key] = pool[i % pool.length];
    });
  }
  return out;
};

export const CATEGORY_IMAGES = { ...GENERIC, ...buildTiles() };

// Wide hero banner per collection — a signature woman from that community.
export const COLLECTION_IMAGES = {
  "black-women": uWide("photo-1656473031961-9d5d9ee19f40"),
  "latina-women": PX(28224108),
  "south-asian-women": PX(29601839),
  "mena-women": PX(30457752),
  "caribbean-women": PX(28168488),
  "east-asian-women": PX(1124833),
  "african-women": PX(34324837),
  "indigenous-women": PX(36361460),
  "pacific-islander-women": PX(20736371),
  "mixed-race-women": PX(16176593),
  "immigrant-women": PX(5935268),
  "jewish-women": PX(4040830),
  "women-40-plus": "https://images.unsplash.com/photo-1667785225959-9f2d0f2bcf42?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  "caregivers": "https://images.unsplash.com/photo-1633099796331-d6397038b513?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  "women-of-faith": "https://images.unsplash.com/photo-1536766768598-e09213fdcf22?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  "women-in-leadership": "https://images.unsplash.com/photo-1573497491765-dccce02b29df?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
};
